<template>
  <div class="m-section">
    <div class="m-section__header">
      <div class="row justify-content-center align-items-center">
        <div class="col-9">
          <div class="m-section__headline">
            Tu nivel de Menú Diario
            <span
              class="m-section__date ml-2"
              v-if="getStatistics.hasOwnProperty('labelDate')"
            >
              Del {{ getStatistics.labelDate }}
            </span>
            <span
              class="m-section__date ml-2"
              v-if="getStatistics.hasOwnProperty('week')"
            >
              <strong>|</strong>&nbsp; {{ getStatistics.week }}
            </span>
          </div>
        </div>
        <div class="col-3">
          <LinkPdf />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-6" v-if="getStatistics.hasOwnProperty('level')">
        <CardPeriod
          :data="getStatistics.level"
          :name="'level'"
          :title="'Nivel Menú Diario'"
          :info="LEVEL_HELP_TEXT"
        />
      </div>
      <div
        class="col-md-3 col-6"
        v-if="getStatistics.hasOwnProperty('claimsRatio')"
      >
        <CardPeriod
          :data="getStatistics.claimsRatio"
          :name="'ratio'"
          :action="true"
          :title="'Ratio de incidencias'"
          :info="INCIDENTS_HELP_TEXT"
          :url="'/reclamos'"
        />
      </div>
      <div
        class="col-md-3 col-6"
        v-if="getStatistics.hasOwnProperty('averageWaitExcessMinutes')"
      >
        <CardPeriod
          :data="getStatistics.averageWaitExcessMinutes"
          :name="'wait'"
          :action="true"
          :title="'Espera del repartidor'"
          :info="DEALER_WAIT_HELP_TEXT"
          :url="'/niveles'"
        />
      </div>
      <div class="col-md-3 col-6" v-if="getStatistics.hasOwnProperty('rating')">
        <CardPeriod
          :data="getStatistics.rating"
          :name="'rating'"
          :action="true"
          :title="'Calificación de pedidos'"
          :info="RATINGS_HELP_TEXT"
          :url="'/feedback'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CardPeriod from "@/components/Metrics/CardPeriod";
import LinkPdf from "@/components/Metrics/LinkPdf";
import { mapGetters } from "vuex";
import {
  LEVEL_HELP_TEXT,
  INCIDENTS_HELP_TEXT,
  DEALER_WAIT_HELP_TEXT,
  RATINGS_HELP_TEXT
} from "@/utils/dailyMenuLevelHelpTexts";

export default {
  data: () => ({
    LEVEL_HELP_TEXT,
    INCIDENTS_HELP_TEXT,
    DEALER_WAIT_HELP_TEXT,
    RATINGS_HELP_TEXT
  }),
  components: {
    CardPeriod,
    LinkPdf
  },
  computed: {
    ...mapGetters("metrics", ["getStatistics"])
  }
};
</script>
